Postlogin = (function (my) {
    my.AudioSearch = {};
    const self = my.AudioSearch;

    self.init = function () {
        // 🔊 Audio search box event
        const $audioSearch = $('#audio-search');
        $audioSearch.on('keyup', _.debounce(getSearchItems, 500));

        // Fires to get possible search items as long as the string is long enough
        function getSearchItems() {
            const searchText = $audioSearch.val().trim();

            if (searchText.length > 2) {
                $.ajax({
                    data: { searchString: searchText },
                    type: 'POST',
                    url: '/admin/tools/audio-search/json/',
                    beforeSend() {
                        $('#ajax-progress-indicator').fadeIn();
                        $('#audioSearchResults').css('opacity', 0.5);
                    },
                    complete() {
                        $('#ajax-progress-indicator').fadeOut();
                        $('#audioSearchResults').css('opacity', 1);
                    },
                }).done((json) => {
                    const searchResults = json.data;
                    refreshList(searchResults);
                });
            }
        }

        // Refresh the list of matches from the database results
        function refreshList(results) {
            // take the data, build the html, get it back, then append it.
            const $audioSearchResults = $('#audioSearchResults');
            $audioSearchResults.empty();

            // Loop through the results, build the DOM element and append it.
            results.forEach((element) => {
                const $result = buildResultElement(element);
                $audioSearchResults.append($result);

                // After appending attach a play/pause event to the buttons
                $result.find('.playButton').on('click', () => {
                    toggleAudio($result);
                });
            });
        }

        function buildResultElement(element) {
            const audioText = element.audio_text;
            const audioLink = element.result_audio;
            const $listGroupItem = $(
                '<div class="list-group-item">'
                    + `<div class="list-view-info info-text">${audioText}</div>`
                    + '<div class="list-view-action">'
                    + `<a href="${audioLink}" download target="_blank"><span class="btn btn-default">Download</span></a>`
                    + `<audio><source src="${audioLink}" /></audio><span class="btn btn-default playButton"><i class="fa fa-play" aria-hidden="true"></i></span>`
                    + '</div>',
            );

            return $listGroupItem;
        }

        function toggleAudio(audioElementToPlay) {
            // This handles all the things that need to happen when the audio button is clicked
            const audioElement = audioElementToPlay.find('audio');
            const playPauseButton = audioElementToPlay.find('i');

            // This will fire the scoped functions whether or not the button clicked is paused or playing
            if (audioElement[0].paused) {
                playCurrent();
            } else {
                pauseCurrent();
            }

            function playCurrent() {
                // grab the current object and then toggle it's classes, also pause & remove classes from other audio elements
                const currentAudioElementButton = $(audioElement[0]).next().children('i');

                $.each($('audio'), (i, val) => {
                    val.pause();
                    if (audioElement[0] === val) {
                        val.play();
                        // eslint-disable-next-line no-param-reassign
                        val.onended = function () {
                            toggleAudioClasses(currentAudioElementButton);
                        };
                        currentAudioElementButton.toggleClass('fa-play fa-pause');
                    } else {
                        $(val).next().children('i').removeClass('fa-pause')
                            .addClass('fa-play');
                    }
                });
            }

            function pauseCurrent() {
                audioElement[0].pause();
                toggleAudioClasses(playPauseButton);
            }

            function toggleAudioClasses(elementToToggle) {
                // This could just be called each time, but I made it into a scoped function in case it needs to be used in different ways.
                elementToToggle.toggleClass('fa-play fa-pause');
            }
        }
    };

    return my;
}(Postlogin || {}));
